// THE OWNER'S DOOR to the new console's switch (/ui-preview, lib/ui-v2.ts), drawn in today's console. Nobody but the
// owner sees it (/api/me canApprovePayouts, from a successful read), and nobody sees it once he has switched over or
// when there is nothing to preview — then it draws nothing at all.
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { readState } from '../../lib/read-state';
import { PREVIEW_OFFERED, PREVIEW_ON } from '../../lib/ui-v2';

export function NewConsoleDoor({ className = '' }: { className?: string }) {
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me(), enabled: PREVIEW_OFFERED && !PREVIEW_ON });
  if (!PREVIEW_OFFERED || PREVIEW_ON || readState(me) !== 'known' || !me.data?.canApprovePayouts) return null;
  return <Link to="/ui-preview" className={`btn-link text-meta ${className}`}>Use the new console</Link>;
}
